import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from "@mui/lab";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { PasswordField } from "@ssf/components";
import { setAuthorization, setMemberPassword } from "@ssf/memdb-api";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutationWithAuthError } from "./QueryError.js";
const isValidPassword = (password) => /^\S{6,}$/.test(password);
export const ChangePasswordDialog = ({ open, memberId, accessToken, onClose, }) => {
    const { t } = useTranslation("ChangePasswordDialog");
    const [password, setPassword] = useState("");
    const { mutate: changePassword, isPending, isSuccess, reset, } = useMutationWithAuthError(["setMemberPassword", memberId], (newPassword) => {
        setAuthorization(accessToken);
        return setMemberPassword({
            id: memberId,
            password: newPassword,
        });
    });
    const passwordIsValid = isValidPassword(password);
    const handleClose = () => {
        if (isPending) {
            return;
        }
        setPassword("");
        reset();
        onClose();
    };
    return (_jsx(Dialog, { open: open, onClose: handleClose, fullWidth: true, maxWidth: "xs", children: _jsxs("form", { onSubmit: (event) => {
                event.preventDefault();
                if (!isPending && passwordIsValid) {
                    changePassword(password);
                }
            }, children: [_jsx(DialogTitle, { children: t("title") }), isSuccess ? (_jsxs(_Fragment, { children: [_jsx(DialogContent, { children: _jsx(Alert, { severity: "success", children: t("success") }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: handleClose, children: t("close") }) })] })) : (_jsxs(_Fragment, { children: [_jsx(DialogContent, { children: _jsx(PasswordField, { autoFocus: true, required: true, label: t("password"), value: password, helperText: t("description"), sx: { mt: 1 }, slotProps: {
                                    htmlInput: { minLength: 6, pattern: "\\S{6,}" },
                                }, onChange: (event) => setPassword(event.target.value) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: handleClose, color: "inherit", disabled: isPending, children: t("cancel") }), _jsx(LoadingButton, { type: "submit", loading: isPending, disabled: isPending || !passwordIsValid, children: t("submit") })] })] }))] }) }));
};
//# sourceMappingURL=ChangePasswordDialog.js.map